/**
 * User: Rob Richard
 * Date: 9/4/14
 * Time: 11:04 AM
 */

'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');
var PaymentAuthorization = require('bunsen/models/ecomm/PaymentAuthorization');

module.exports = SoaCollection.extend({
    model: PaymentAuthorization,
    getOfferPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isOfferPaymentAuthorization();
        }, this);
    },
    getShippingPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isShippingPaymentAuthorization();
        }, this);
    },
    getActiveOfferPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isActive() && paymentAuth.isOfferPaymentAuthorization();
        }, this);
    },
    getActiveShippingPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isActive() && paymentAuth.isShippingPaymentAuthorization();
        }, this);
    },
    getDeniedCheckoutPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isDenied() && paymentAuth.isCheckoutPaymentAuthorization();
        }, this);
    },
    getCurrentCheckoutPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isCurrentCheckout() && paymentAuth.isCheckoutPaymentAuthorization();
        }, this);
    },
    getCurrentBalanceDuePaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isCurrentBalanceDue();
        }, this);
    },
    getBalanceDuePaymentAuthorizationForProcessing: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isReadyForProcessing() && paymentAuth.isBalanceDuePaymentAuthorization();
        }, this);
    },
    getCheckoutPaymentAuthorizationForProcessing: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isReadyForProcessing() && paymentAuth.isCheckoutPaymentAuthorization();
        }, this);
    },
    getStagedPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isStagedPaymentAuth();
        }, this);
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/PaymentAuthorizations.js
// module id = 161
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54